



import { Alert, Stack } from "@mui/material";

const CustomAlert = props => {
    const { error, customClass, success, style } = props;

    return (
        <Stack className={customClass} style={style}>
            {
                error ? <Alert severity="error"><div dangerouslySetInnerHTML={{ __html: error }} />
                </Alert> : <Alert severity="success">{success}</Alert>
            }
        </Stack>
    )
}

export default CustomAlert